import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
// Contentsquare / Hotjar tracking
const csScript = document.createElement("script");
csScript.src = "https://t.contentsquare.net/uxa/913cebb3b9169.js";
csScript.async = true;
document.head.appendChild(csScript);
render(<App data-id="element-310" />, document.getElementById("root"));